import React from "react";

/**
 * One achievement row. Tailwind utilities + named theme tokens only — the
 * bootstrap `Row`/`Col`/`Badge` markup it replaced resolved to no design
 * system of its own.
 */
const CourseRow = ({title, attained_on, index, type}) => {
  // Helper to format ISO date string to DD/MM/YYYY
  const formatDate = (isoString) => {
    if (!isoString) return "";
    const date = new Date(isoString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  return (
    <div
      className={`flex flex-wrap items-center gap-x-4 gap-y-1 border-b border-border py-3 text-sm ${
        index === 0 ? "border-t" : ""
      }`}
    >
      <span className="min-w-0 flex-1 truncate font-semibold text-foreground">
        {title || "Untitled"}
      </span>
      <span className="rounded-full bg-success/10 px-2 py-0.5 text-[11px] font-semibold capitalize text-success">
        {type || "course"}
      </span>
      <span className="text-xs text-muted-foreground">Attained on {formatDate(attained_on) || "—"}</span>
    </div>
  );
};

export default CourseRow;
